/**
 * CadenceTab.tsx — `cadence_instructions` (ADR-084 D1), the agentic
 * editor's Cadence tab (design doc §Cadence tab, E12-S3a). One textarea,
 * `max_length=1500`, counter, no other controls. Always visible regardless
 * of the Admin role (design doc §Empty and error states).
 */

import { useTranslation } from 'react-i18next';
import { AGENT_CONFIG_MAX_LENGTHS, type SkillVersionFieldError } from '../../api/types';
import { CounterField } from './agenticFieldHelpers';

export interface CadenceTabProps {
  cadenceInstructions: string;
  onChange: (next: string) => void;
  disabled?: boolean;
  fieldErrors: SkillVersionFieldError[];
}

export const CadenceTab = ({
  cadenceInstructions,
  onChange,
  disabled = undefined,
  fieldErrors,
}: CadenceTabProps) => {
  const { t } = useTranslation();
  const error = fieldErrors.find((e) => e.field_path === 'cadence_instructions')?.reason;
  return (
    <section aria-labelledby="agentic-cadence-heading" className="flex flex-col gap-4">
      <h3 id="agentic-cadence-heading" className="text-h3 text-ink-1">
        {t('config.editAgentic.cadence.heading')}
      </h3>
      <CounterField
        id="agentic-cadence-instructions"
        label={t('config.editAgentic.cadence.label')}
        value={cadenceInstructions}
        maxLength={AGENT_CONFIG_MAX_LENGTHS.cadenceInstructions}
        onChange={onChange}
        disabled={disabled}
        multiline
        rows={10}
        error={error}
      />
    </section>
  );
};
